<template>
  <div id="paginaCostoProduzioni">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Costo Produzioni</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id='dropStagioni' ref='dropStagioni' :query='queryStagioni' :dataSource='stagioniData'
                  :index='stagioniIndex' :fields='stagioniFields' :change='aggiornaCostoProduzioni'
                  v-model="stagioneCorrente"
                  placeholder='Seleziona un Anno'></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id='filtroCorrente' ref='filtroCorrente' :dataSource='filtroCorrenteList'
                  :fields='filtroCorrenteFields' :change='aggiornaCostoProduzioni'
                  v-model="filtroCorrente"
                  placeholder='Seleziona filtro spettacoli'></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                <b-spinner label="Loading..."></b-spinner>
              </b-col>
              <b-col xl="4" md="4" class="pt-1">
                <ejs-button id="downloadRiassunto" @click.native="downloadRiassunto()">Scarica Excel Riassuntivo</ejs-button>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <!-- aggiungere button -->
                <div id="GridParent">
                  <ejs-grid id="gridA" ref="gridA" :dataSource="costoProduzioniFilteredData" :allowSorting="true"
                    :height="gridA.height" :allowFiltering="true" locale="it-IT"
                    :filterSettings="gridA.filterOptions" :editSettings="gridA.editOptions"
                    :actionBegin="gridAactionBegin" :actionComplete="gridAactionComplete">
                    <e-columns>
                      <e-column field="id" headerText="ID" :isPrimaryKey="true" width="30"></e-column>
                      <e-column field="titolo" headerText="Titolo" width="100"></e-column>
                      <e-column field="tot_preventivo" headerText="Tot Preventivo" width="80" format="C2"></e-column>
                      <e-column field="tot_consuntivo" headerText="Tot Consuntivo" width="80" format="C2"></e-column>
                      <e-column field="scostamento" headerText="Scostamento" width="100" format="C2"></e-column>
                      <e-column field="raggiungimentoPerc" headerText="Raggiungimento %" width="100" format="C2"></e-column>
                      <e-column field="totScostamento" headerText="Scostamento Cumulato" width="100"></e-column>
                    </e-columns>
                    <e-aggregates>
                      <e-aggregate>
                        <e-columns>
                          <e-column type="Sum" field="tot_preventivo" format="Tot € ######.##"></e-column>
                          <e-column type="Sum" field="tot_consuntivo" format="Tot € ######.##"></e-column>
                        </e-columns>
                      </e-aggregate>
                    </e-aggregates>
                  </ejs-grid>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>

  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, LinkPlugin, AlertPlugin, ProgressPlugin,
  ToastPlugin, SpinnerPlugin,
} from 'bootstrap-vue'
// import Vuexy
// import Syncfusion

import { enableRipple, setCulture, setCurrencyCode } from '@syncfusion/ej2-base'
//import { Query } from '@syncfusion/ej2-data'
import {
  TextBoxPlugin, NumericTextBoxPlugin,
} from '@syncfusion/ej2-vue-inputs'
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  DropDownListPlugin,
} from '@syncfusion/ej2-vue-dropdowns'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import {
  GridPlugin,
  Aggregate, Sort
} from '@syncfusion/ej2-vue-grids'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'

const axios = require('axios')
// use bootstrap-vue
Vue.use(LayoutPlugin)
Vue.use(TabsPlugin)
Vue.use(CardPlugin)
Vue.use(ButtonPlugin)
Vue.use(DropdownPlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ProgressPlugin)
Vue.use(ToastPlugin)
Vue.use(SpinnerPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(DropDownListPlugin)
Vue.use(DialogPlugin)
Vue.use(GridPlugin)
Vue.use(DropDownButtonPlugin)
enableRipple(true)
// api
const apiSpettacoliRicercaUrl = "/demo/api/spettacolo/ricerca";
//const apiCostoProduzioniRicercaUrl = '/demo/api/costoproduzioni/ricerca'
const apiCostoAnnoUrl = '/demo/api/costoproduzioni/export_bilancio_anno'
const apiRiassuntoStagioneUrl = '/demo/api/costoproduzioni/export_riassunto_stagione'
setCulture('it')
setCurrencyCode('EUR')

export default Vue.extend({
  components: {
  },
  data() {
    return {
      loading: false,
      // per gestione stagioni
      stagioniData: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      stagioniFields: { value: "val", text: "label" },
      filtroCorrenteList: [
        { label: "Tutti gli Spettacoli", val: "tutti" },
        { label: "Spettacoli Ministero", val: "ministero" },
        { label: "Spettacoli Ospitati", val: "ospitati" },
        { label: "Spettacoli Organizzatore Coccia", val: "coccia" },
        { label: "Spettacoli altri Organizzatori", val: "altriOrganizzatori" },
      ],
      filtroCorrenteFields: { text: "label", value: "val" },
      stagioniIndex: -1,
      queryStagioni: null,
      stagioneCorrente: null,
      // gestione elementi nascosti
      nonMostrare: false,
      // generali
      settings: {
        formatoData: 'dd-MM-yyyy',
        formatoOra: 'HH:mm',
        intervalloOra: 15,
      },
      // costoProduzioni
      costoProduzioniFullData: [], // elenco completo dati costoProduzioni
      costoProduzioniFilteredData: [], // elenco filtrato dati costoProduzioni
      costoProduzioniActiveId: 0, // Id allestimento attivo (0 se nuovo)
      costoProduzioniActiveData: {}, // dati completi dell allestimento attivo
      costoProduzioniSavedData: {}, // dati completi dell allestimento attivo
      costoProduzioniDefaultData: {}, // dati completi di default per nuovi costoProduzioni
      filtroCorrente: "tutti", // tmp
      sommaScostamento: 0,

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: 'Excel' },
      }, //
    }
  },
  created() {
    // log
    console.log('Pagina Costo Produzioni Creata')
  },
  mounted() {
    // disabilito gridA
    this.$refs.gridA.$el.classList.add('disablegrid')
    document.getElementById("GridParent").classList.add('wrapper')
    // focus su dropStagioni
    this.$refs.dropStagioni.ej2Instances.focusIn()
  },

  provide: {
    grid: [Aggregate, Sort],
  },
  methods: {
    roundNumber: function(val) {
      return Math.round(val * 100) / 100;
    },
    downloadRiassunto: function() {
      let datiDaInviare = {anno: this.stagioneCorrente}
      useJwt.post(apiRiassuntoStagioneUrl, datiDaInviare, { responseType: "blob" }).then((r)=>{
        let fileName = r.headers["content-disposition"].split("filename=")[1];
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore stagione non selezionata")
      });
    },

    // queryCellInfo: function (args) {
    //     if (args.column.field === "totScostamento") {
    //       // console.log(args.data.scostamento)
    //       this.sommaScostamento += args.data.scostamento
    //       const fieldVal = this.roundNumber(this.sommaScostamento)
    //       args.cell.innerText = fieldVal.toString()
    //     }
    // },
    // per dropdownlist combinate
    aggiornaCostoProduzioni: function (e) {
      this.loading = true
      // devo caricare le info sugli spettacoli di una stagione
      console.log("Recupero spettacoli stagione dal backend");
      const datiDaInviare = {
        anno: this.stagioneCorrente,
      };
      if (datiDaInviare.stagione === null) {
        console.log("Stagione non ancora selezionata");
      } else {
        useJwt.post(apiCostoAnnoUrl, datiDaInviare).then((d) => {
          // gestione risposta
          console.log("RISPOSTA BACKEND")
          // console.log(d.data)
          this.costoProduzioniFullData = d.data
          this.costoProduzioniFullData.forEach((obj) => {
            obj.scostamento = obj.tot_consuntivo - obj.tot_preventivo;
            if ((obj.tot_preventivo > 0) && (obj.tot_consuntivo > 0)) {
              obj.raggiungimentoPerc = this.roundNumber(100*obj.tot_consuntivo/obj.tot_preventivo);
            } else { this.raggiungimentoPerc = null; }
          })
          console.log("Recupero elenco spettacoli dal backend per l'anno selezionato");
          const datiDaInviare2 = {
            stagione: this.stagioneCorrente,
          };
          useJwt.post(apiSpettacoliRicercaUrl, datiDaInviare2).then((d) => {
            this.spettacoliFullData = d.data;
            // console.log("Elenco Spettacoli:");
            // console.log(this.spettacoliFullData);
            this.loading = false
            this.$refs.gridA.$el.classList.remove('disablegrid');
            document.getElementById("GridParent").classList.remove('wrapper');
            // Filtro costoProduzioniFullData in base alle scelte fatte
            let costiProduzioniSelezionate = []; // initialize an empty array
            this.costoProduzioniFullData.forEach((obj, index) => {
              const currTitoloSpett=obj.titolo;
              // console.log(currTitoloSpett);

              const obj2 = this.spettacoliFullData.find((obj) => {
                return obj.titolo === currTitoloSpett
              });
              if (obj2 !== undefined) {
                obj.dataInizio = new Date(obj2.dataInizio)
                //console.log(obj2.id);
                // gestisco i filtri
                if(this.filtroCorrente=="tutti"){
                  costiProduzioniSelezionate.push(obj);
                }
                else if(this.filtroCorrente=="ministero"){
                  if(obj2.ministero==true){
                    //console.log("Aggiungo elemento all'elenco");
                    costiProduzioniSelezionate.push(obj);
                  }
                }
                else if(this.filtroCorrente=="ospitati"){
                  if(obj2.ospitalita==true){
                    //console.log("Aggiungo elemento all'elenco");
                    costiProduzioniSelezionate.push(obj);
                  }
                }
                else if(this.filtroCorrente=="coccia"){
                  if(obj2.organizzatore=="teatroCoccia"){
                    //console.log("Aggiungo elemento all'elenco");
                    costiProduzioniSelezionate.push(obj);
                  }
                }
                else if(this.filtroCorrente=="altriOrganizzatori"){
                  if(obj2.organizzatore!="teatroCoccia"){
                    //console.log("Aggiungo elemento all'elenco");
                    costiProduzioniSelezionate.push(obj);
                  }
                }
              }
            })
            costiProduzioniSelezionate.sort(function(a,b){
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return (b.dataInizio - a.dataInizio);
            }).reverse()

              // popolo l'elenco filtrato costi produzione
              console.log("aggiorno costo produzioni filtrate")
              this.costoProduzioniFilteredData=costiProduzioniSelezionate;
              this.sommaScostamento = 0
              this.costoProduzioniFilteredData.forEach((obj) => {
                  this.sommaScostamento += obj.scostamento
                  obj.totScostamento = this.roundNumber(this.sommaScostamento)
              });
              this.costoProduzioniFilteredData = [...this.costoProduzioniFilteredData];
              //console.log(this.costoProduzioniFilteredData)
          });
        });
      }
    },

    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        // Add and edit operations
        if (e.requestType === 'save') {
          const editedData = e.data
          console.log(editedData)
          // The default edit operation is cancelled
          e.cancel = true
          const editUrl = `${apiAllestimentiUrl}/${editedData.id}`
          useJwt.patch(editUrl, editedData).then(res => {
            console.log(res)
            if (res.status === 200) {
              // se tutto OK
              // Flag is enabled to skip this execution when grid ends add/edit
              this.gridAFlag = true
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridA.endEdit()
            } else {
              this.makeToast('primary', 'Attenzione', 'Salvataggio allestimento non riuscito')
            }
          })
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      if (e.requestType === 'save') {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },
    noop() {
      console.log("premuto enter")
    },

  },
  computed: {
    hasChanged() {
      // console.log(this.allestimentiActiveData)
      // console.log(this.allestimentiSavedData)
      return Object.keys(this.allestimentiActiveData).some(field => this.allestimentiActiveData[field] !== this.allestimentiSavedData[field])
    },
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-calendars/styles/material.css';
@import '~@syncfusion/ej2-calendars/styles/datepicker/material.css';
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import '~@syncfusion/ej2-schedule/styles/material.css';
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
@import "~@syncfusion/ej2-treegrid/styles/material.css";
@import "~@syncfusion/ej2-vue-gantt/styles/material.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/material.css";
@import "~@syncfusion/ej2-vue-kanban/styles/bootstrap.css";

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
